<template src="./Company.html"></template>

<script>
import { required } from 'vuelidate/lib/validators'
import { createCompany, updateCompany, createSubClient, getSubClients, deleteSubClient } from '../../../services'
import FileUpload from '../../../components/Files/FileUpload/FileUpload'

export default {
  name: 'Company',
  components: {
    FileUpload
  },
  data: () => ({
    company: { active: true },
    update: false,
    subClients: []
  }),
  validations () {
    return {
      company: {
        name: { required },
        nit: { required },
        email: { required },
        phoneNumber: { required },
        city: { required }
      }
    }
  },
  created () {
    this.isUpdateCompany()
    this.getListSubClients()
  },
  methods: {
    isUpdateCompany () {
      if (this.$route.params.updateCompany) {
        this.company = this.$route.params.updateCompany
        this.update = true
      }
    },
    reset () {
      this.company = {}
      this.update = false
    },
    async saveCompany () {
      try {
        if (this.$v.$invalid) {
          return false
        } else {
          // Keep the created company so the documents section becomes available without reloading
          this.company = await createCompany(this.company)
          this.update = true
          this.$swal({
            text: 'Se agregó la empresa.',
            buttons: false,
            icon: 'success',
            timer: 3000
          })
        }
      } catch (err) {
        console.error('Error on save company', err)
        this.$swal({
          text: err.message ?? 'Ocurrio un error, intenta mas tarde.',
          buttons: false,
          icon: 'error',
          timer: 3000
        })
      }
    },
    async changeCompany (company) {
      try {
        await updateCompany(company)
        this.$swal({
          text: 'Se Actualizo la empresa.',
          buttons: false,
          icon: 'success',
          timer: 3000
        })
        this.reset()
      } catch (err) {
        console.error('Error on update company', err)
        this.$swal({
          text: err.message ?? 'Ocurrio un error, intenta mas tarde.',
          buttons: false,
          icon: 'error',
          timer: 3000
        })
      }
    },
    addSubClient () {
      this.subClients.push({
        name: '',
        nit: '',
      })
    },
    ifDeleteSubClient (subClient) {
      this.$swal({
        title: '¿Está seguro de eliminar el cliente?',
        icon: 'warning',
        buttons: true,
        dangerMode: true
      }).then(async (value) => {
        if (value) {
          const index = this.subClients.indexOf(subClient)
          if (index > -1) {
            this.subClients.splice(index, 1)
            if (subClient.id) {
              await deleteSubClient(subClient.id)
              this.$swal({
                text: 'Se eliminó el cliente.',
                buttons: false,
                icon: 'success',
                timer: 3000
              })
              this.getListSubClients()
            }
          }
        }
      })
    },
    async getListSubClients () {
      try {
        this.subClients = await getSubClients(this.company.id)
      } catch (err) {
        console.error('Error on get sub clients', err)
      }
    },
    async newSubClient (subClient) {
      try {
        await createSubClient({ ...subClient, companyId: this.company.id })
        this.$swal({
          text: 'Se agregó el cliente.',
          buttons: false,
          icon: 'success',
          timer: 3000
        })
        await this.getListSubClients()
      } catch (err) {
        console.error('Error on create sub client', err)
        this.$swal({
          text: err.message ?? 'Ocurrio un error, intenta mas tarde.',
          buttons: false,
          icon: 'error',
          timer: 3000
        })
      }
    },
  }
}
</script>
